import { render } from "./ComponentHeader.vue?vue&type=template&id=551f6a1d&scoped=true"
import script from "./ComponentHeader.vue?vue&type=script&lang=js"
export * from "./ComponentHeader.vue?vue&type=script&lang=js"

import "./ComponentHeader.vue?vue&type=style&index=0&id=551f6a1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551f6a1d"]])

export default __exports__